import { commonUtils } from '@/helpers/commonUtils'
import PdfPage, { PageHeader, useMarkdownFontSize, } from '../PdfPage/PdfPage'
import styles from './PdfPage8.module.less'
import MarkdownRenderer from '@/components/MarkdownRenderer/MarkdownRenderer'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'


interface Props {
  project: ProjectModels.ProjectDetail
  onRendered: (cnt: number) => void
  no: number
}

function PdfPage8({ project, onRendered, no }: Props) {
  const { t } = useTranslation()
  const BOX_MAX_HEIGHT = 690
  const summaryRef = useRef<HTMLDivElement>(null)
  const { fontsize, end } = useMarkdownFontSize(summaryRef, BOX_MAX_HEIGHT)

  useEffect(() => {
    if (end) {
      onRendered(1)
    }
  }, [end])

  return (
    <PdfPage bgSrc={commonUtils.getImagePath('PDFDownload/pdf-page-7/PDF-bg.jpg')} no={no}>
      <div className={styles.pdfPage8}>
        <PageHeader
          project={project}
          text={'02.' + t('dashboard.projectDetailPage.primaryAnalysis')}
        />
        <div className={styles.content}>
          <div className={styles.left}>
            <div className={styles.title}>
              <img
                src={commonUtils.getImagePath('projectDetailPage/range-title-light.png')}
                alt=''
              />
              <span>{t('dashboard.projectDetailPage.storyboardView.summary')}</span>
            </div>
            <div className={styles.summary} ref={summaryRef} >
              <MarkdownRenderer style={{ fontSize: fontsize }} markdownText={project.globalMetrics.reason.performance} />
            </div>
          </div>

          <div className={styles.right}>
            <img
              className={styles.img}
              src={commonUtils.getImagePath('PDFDownload/pdf-page-8/right-icon.jpg')}
            />
          </div>
        </div>
      </div>
    </PdfPage>
  )
}

export default PdfPage8
